import React from 'react';
import { Edit, TextInput, required, SimpleForm, ImageInput, ImageField, NumberInput } from 'react-admin';
import { Grid } from '@mui/material';
import { PERMISSIONS } from '../../constants';
import Permission from '../../components/Permission';
import { ImageInformations } from '../../components';

const ProductsCategoryEdit = props =>
    <Permission permission={PERMISSIONS.CREATE_PRODUCT_CATEGORIES}>
        <Edit {...props} title="Editar categoria de produto">
            <SimpleForm>
                <Grid container spacing={2} sx={{ maxWidth: 800 }}>
                    <Grid size={12}>
                        <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} fullWidth />
                    </Grid>
                    <Grid size={12}>
                        <ImageInput source="imagefile" label="Imagem" accept={{ 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] }}>
                            <ImageField source="src" label="Imagem" />
                        </ImageInput>
                        <ImageInformations position={-20}/>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <NumberInput label="Posição na tela inicial do App" source="appIndex" fullWidth />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Edit>
    </Permission>

export default ProductsCategoryEdit;
